<app-header *ngIf="isLoggedIn()"></app-header> 
<router-outlet></router-outlet> 
<app-footer></app-footer>